<template>
  <div>
    <RevIllustration
      :alt="
        i18n(translations.selectedDesign, { designType: selectedDesign.type })
      "
      class="rounded-md overflow-hidden"
      :height="498"
      :src="selectedDesign.assetUrl"
      :width="498"
    />

    <RevCardCarousel
      class="mt-48 [&_li]:w-[112px]"
      :next-alternative-text="i18n(translations.alternativeNext)"
      :prev-alternative-text="i18n(translations.alternativePrevious)"
      :title="i18n(translations.title)"
    >
      <div v-for="designPicker in designPickers" :key="designPicker.id">
        <RevIllustration
          :alt="
            i18n(translations.chooseDesign, { designType: designPicker.type })
          "
          class="rounded-md overflow-hidden"
          :height="70"
          :src="designPicker.thumbnailUrl"
          :width="112"
          @click="selectedDesign = designPicker"
        />
      </div>
    </RevCardCarousel>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCardCarousel } from '@ds/components/CardCarousel'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './DesignPickers.translations'

const i18n = useI18n()
type DesignPicker =
  ApiSpecs['/api/gift-cards/v1/product-page/giftcard']['GET']['response']['designPickers'][number]

const props = defineProps<{
  designPickers: DesignPicker[]
}>()

const selectedDesign = ref<DesignPicker>(props.designPickers[0])
</script>
